import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_DATAENTRY_PLANTS,
    GET_DATAENTRY_ANIMALS,
    ADD_DATAENTRY_PLANT,
    ADD_DATAENTRY_ANIMAL,
    GET_LEADERBOARD,
} from "./actionTypes"
import {
  getDataEntryPlantsSuccess,
  getDataEntryPlantsFail,
  addDataEntryPlantFail,
  addDataEntryPlantSuccess,
  getDataEntryAnimalsSuccess,
  getDataEntryAnimalsFail,
  addDataEntryAnimalFail,
  addDataEntryAnimalSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import {
  saveDataEntryPlant,
  fetchDataEntryPlants,
  getLoggedInUser,
  saveDataEntryAnimal,
  fetchDataEntryAnimals,
  fetchLeaderboard
} from "../../helpers/fakebackend_helper"

function* onFetchDataEntryPlants() {
  try {
    console.log("asdasdf")
    const response = yield call(fetchDataEntryPlants)
    yield put(getDataEntryPlantsSuccess(response))
  } catch (error) {
    yield put(getDataEntryPlantsFail(error))
  }
}

function* onFetchDataEntryAnimals() {
  try {
    const response = yield call(fetchDataEntryAnimals)
    yield put(getDataEntryAnimalsSuccess(response))
  } catch (error) {
    yield put(getDataEntryAnimalsFail(error))
  }
}

function* onSaveDataEntryPlant ({ payload: plant}) {
  try {     
     console.log("DFGDFGD")
     const user = getLoggedInUser()
     plant["username"] = user
console.log("ASAS")
     const response = yield call(saveDataEntryPlant, plant)
     yield put(addDataEntryPlantSuccess(response))
  } catch (error) { 
     yield put(addDataEntryPlantFail(error))
  }
}

function* onSaveDataEntryAnimal ({ payload: animal}) {
  try {
     const user = getLoggedInUser()
     plant["username"] = user
     const response = yield call(saveDataEntryAnimal, animal)
     yield put(addDataEntryAnimalSuccess(response))
  } catch (error) {
     yield put(addDataEntryPlant(error))
  }
}

function* onFetchLeaderboard() {
  try {
    const response = yield call(fetchLeaderboard)
    yield put(getLeaderboardSuccess(response))
  } catch (error) {
    yield put(getLeaderboardFail(error))
  }
}

function* goalsHackathon() {
  yield takeEvery(GET_DATAENTRY_PLANTS, onFetchDataEntryPlants)
  yield takeEvery(ADD_DATAENTRY_PLANT, onSaveDataEntryPlant)
  yield takeEvery(GET_DATAENTRY_ANIMALS, onFetchDataEntryAnimals)
  yield takeEvery(ADD_DATAENTRY_ANIMAL, onSaveDataEntryAnimal)
  yield takeEvery(GET_LEADERBOARD, onFetchLeaderboard)
}

export default goalsHackathon
